<template>
  <div class="category-list">
    <div
      v-for="category in categories[selectedProductType]"
      :key="category.id"
      class="category-item"
      :style="categorySelection === 'single' ? singleChoice : ''"
    >
      <label v-if="categorySelection === 'multiple'">
        <input :checked="isChecked(category)" type="checkbox" @change="filterMultiple($event, category)" />
        <span>
          {{ category.name }}
        </span>
      </label>
      <button
        v-if="categorySelection === 'single'"
        type="button"
        @click="filterSingle(category)"
        :class="selectedCategories.some((c) => c.id === category.id) ? 'selected' : ''"
      >
        {{ category.name }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EcommerceFilterCategories',
  props: {
    categorySelection: {
      type: String,
      default: 'multiple',
      validator: (value) => ['multiple', 'single'].includes(value),
    },
  },
  data() {
    return {
      singleChoice: {
        padding: 0,
        'background-color': 'transparent',
        border: 0,
      },
    };
  },
  computed: {
    ...mapState({
      categories: (state) => state.ecommerce.categories,
      selectedProductType: (state) => state.ecommerce.selectedProductType,
      selectedCategories: (state) => state.ecommerce.selectedCategories,
    }),
  },
  created() {
    if (this.categorySelection === 'single') {
      if (this.categories[this.productType].length > 0) {
        const firstCategory = this.categories[this.productType][0];
        this.$store.dispatch('updateSelectedCategories', [firstCategory]);
      }
    }
  },
  methods: {
    filterMultiple(event, category) {
      if (event.target.checked) {
        this.$store.dispatch('updateSelectedCategories', [...this.selectedCategories, category]);
      } else {
        this.$store.dispatch(
          'updateSelectedCategories',
          this.selectedCategories.filter((c) => c.id !== category.id),
        );
      }
    },
    filterSingle(category) {
      this.$store.dispatch('updateSelectedCategories', [category]);
    },
    isChecked(category) {
      return this.selectedCategories.some((c) => c.id === category.id);
    },
  },
};
</script>

<style scoped>
.category-list {
  display: flex;
  flex-wrap: wrap;
}

.category-item {
  flex: 0 0 160px;
  padding-right: 10px;
}

label {
  display: flex;
  align-items: center;
  font-size: 1rem;
}

input[type='checkbox'] {
  border: 2px solid #888888;
  margin: 0 5px 0 0;
  width: 1rem;
  height: 1rem;
}

button {
  cursor: pointer;
  background-color: #ededed;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 0;
  width: 171px;
  height: 53px;
  margin: 10px;
}

.selected {
  background-color: #d1d1d1;
}

@media only screen and (max-width: 40em) {
  .category-list {
    display: grid;
    flex-wrap: nowrap;
    grid-template-columns: 1fr 1fr;
  }

  .category-item {
    flex: none;
    background-color: #ffffff;
    border: 1px solid #d1d1d1;
    display: flex;
    align-items: center;
    padding-left: 20px;
    height: 60px;
  }

  button {
    width: 100%;
    margin: 0;
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// Categories.vue?d375eebe